import axios from 'axios';
import logger from '../utils/logger';

export const getApiBaseUrl = () => {
  const fromEnv = (process.env.REACT_APP_BACKEND_URL || '').trim();
  if (fromEnv) {
    const trimmed = fromEnv.replace(/\/$/, '');
    const normalized = trimmed.replace(/\/api$/i, '');
    return `${normalized}/api`;
  }

  if (process.env.NODE_ENV === 'development') {
    const hostname = window.location.hostname;
    return `http://${hostname}:5000/api`;
  }

  return '/api';
};

export const api = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 300000,
  //headers: {
  //  'Content-Type': 'application/json'
  //}
});

// Helper to clear auth-related localStorage and redirect to login
export const clearAuthAndRedirect = () => {
  try {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('permitted_pages');
    localStorage.removeItem('personnel_id');
    localStorage.removeItem('user_id');
    localStorage.removeItem('last_login');
    localStorage.removeItem('session_id');
    localStorage.removeItem('auth_remember');
  } catch (e) {
    // no-op
  } finally {
    // Force navigation to login
    try {
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    } catch {}
  }
};

api.interceptors.response.use(
  (response) => response,
  (error) => {
    logger.error('API request failed', error, {
      context: 'API',
      data: {
        url: error.config?.url,
        method: error.config?.method,
        status: error.response?.status
      }
    });

    if (error.response) {
      if (error.response.status === 401) {
        logger.warn('Unauthorized access - redirecting to login', {
          context: 'Auth'
        });
        clearAuthAndRedirect();
      }
    }
    throw error;
  }
);
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers = config.headers || {};
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Streaming fonksiyonlarindaki tekrarli token-okuma IIFE'lerinin ortak hali;
// request interceptor'daki dogrudan localStorage okumasi bilerek degistirilmedi
// (hata durumunda davranislari farkli).
export const getAuthToken = (): string | null => {
  try {
    return localStorage.getItem('token');
  } catch {
    return null;
  }
};
